import React, { useEffect, useState } from 'react';
import config from '../../config/config';
import { authHeaders } from '../../utils/session';
import { SA_STATUS, normalizeStatus } from '../../config/saStatus';

// Banner at the top of a ServiceAppointment record (owner-spec 2026-10-19).
// Who the visit is with, its date and the window the customer is told — the same
// window the reminder sends (services/visit_confirmation.visit_slot) — plus where the
// visit stands:
//   פגישה מתוזמנת, not optimised → orange, red "טווח השעות אינו סופי"
//   פגישה מתוזמנת, "מוטב"        → orange, "טרם בוצעה תזכורת מול הלקוח"
//   תואמה התקנה                  → blue, the customer confirmed the window
// Any other status, or no scheduled start → nothing.
const SHOWN_STATUSES = [SA_STATUS.SCHEDULED, SA_STATUS.DISPATCHED];

const SaAssignmentBanner = ({ record }) => {
  const [banner, setBanner] = useState(null);
  const id = record?.Id;
  const status = normalizeStatus(record?.Status);
  const start = record?.SchedStartTime;
  const modified = record?.LastModifiedDate;

  useEffect(() => {
    if (!id || !start || !SHOWN_STATUSES.includes(status)) {
      setBanner(null);
      return undefined;
    }
    let cancelled = false;
    fetch(`${config.api.baseUrl}/api/scheduler/service-appointment/${id}/assignment-banner`,
      { headers: authHeaders() })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (!cancelled) setBanner(data?.banner || null); })
      .catch(() => { if (!cancelled) setBanner(null); });
    return () => { cancelled = true; };
  }, [id, status, start, modified]);

  const bannerStatus = normalizeStatus(banner?.status);
  if (!banner || !SHOWN_STATUSES.includes(bannerStatus)) return null;
  const isDispatched = bannerStatus === SA_STATUS.DISPATCHED;

  return (
    <div style={{
      background: isDispatched ? '#1565c0' : '#ef6c00',
      borderRadius: '6px',
      padding: '14px 20px',
      marginBottom: '8px',
      color: '#fff',
      textAlign: 'center',
      boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
    }}>
      <div style={{ fontWeight: 800, fontSize: '18px' }}>
        הפעילות משובצת ל: {banner.technician || 'לא שובץ טכנאי'}
        {' | '}{banner.date_text}
        {' | '}<span dir="ltr">{banner.window}</span>
      </div>
      {isDispatched ? (
        <div style={{ fontWeight: 700, fontSize: '15px', marginTop: '6px' }}>
          הפעילות תוזכרה מול הלקוח והלקוח אישר טווח שעות
        </div>
      ) : banner.optimized ? (
        <div style={{ fontWeight: 700, fontSize: '15px', marginTop: '6px' }}>
          טרם בוצעה תזכורת מול הלקוח
        </div>
      ) : (
        <div style={{
          display: 'inline-block',
          marginTop: '8px',
          background: '#c62828',
          padding: '4px 14px',
          borderRadius: '4px',
          fontWeight: 800,
          fontSize: '15px',
        }}>
          ⚠ טווח השעות אינו סופי
        </div>
      )}
    </div>
  );
};

export default SaAssignmentBanner;
